class MobDict {
    public name:DictNames;
    public health:string;
    public armor:string;
    public movementSpeed:string;
    public reloadTimeout:string;
    public attack:string;
    public damage:string;
    public boomRadius:string;
    public price:string;
    public level?:number;
}